module.exports = __webpack_public_path__ + "static/media/SUSHIe.30c82158.png";